import { Component, OnInit, ViewChild } from '@angular/core';

import { AreaData } from '../model/area.model';

import { Employee } from './../model/employee.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ApiService } from './../../app/services/api.service';
import { EmployeeDialog } from '../dialogs/employee/employee.component';
import { CustomerBillsComponent } from '../dialogs/customerbills/customerbills.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DuebillsComponent } from '../dialogs/duebills/duebills.component';
import { ControlComponent } from '../dialogs/control/control.component';

@Component({
  selector: 'app-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.scss']
})
export class AccessControlComponent implements OnInit {

  displayedColumns: string[] = [
    'employeeId',
    'employeeName',
    'employeePhone',
    'employeeEmail',
    'employeeCreationDate',
    'actions',
  ];
  dataSource = new MatTableDataSource<Employee>(null);
  employee: Employee = {
    areaCode: null,
    employeeAction: 'add_employee',
    employeePassword: '',
    employeeAreaId: '',
    employeeCreationDate: '2024-02-14',
    employeeEmail: '',
    employeeId: 123,
    employeeName: '',
    employeePhone: null,
    employeeRole: '',
    employeeStatus: '',
    roles:[],
    areas:[]
  };
  selectedEmployee: Employee;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    public dialog: MatDialog,
    private apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    this.getEmployeeDetails();
  }
  employees: Employee[] = [];
  ngOnInit(): void {}
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  getEmployeeDetails() {
    this.apiService.getEmplyees().subscribe((data) => {
      this.dataSource = new MatTableDataSource<Employee>(data.employees);
      const newEmployeeId =  Math.max.apply(Math, data.employees.map(function(o : Employee) { return o.employeeId; }));
      this.employee.employeeId = newEmployeeId + 1;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = (data:
        Employee, filterValue: string) =>
        (data.employeeId.toString() == filterValue) ||
         (data.employeeName.trim().toLowerCase().indexOf(filterValue) !== -1) ;

    });
  }
  addEmployee(): void {
    const dialogRef = this.dialog.open(EmployeeDialog, {
      width: '600px',
      data: this.employee,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getEmployeeDetails();
    });
  }



  assignRoleAndAreasEmployee(employeeData: Employee): void {
    employeeData.employeeAction = 'update';
    const dialogRef = this.dialog.open(ControlComponent, {
      width: '720px',
      data: employeeData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      
    });
  }

  pwdChangeEmployee(employeeData: Employee){
    employeeData.employeeAction = 'pwdchange';
    const dialogRef = this.dialog.open(ControlComponent, {
      width: '720px',
      data: employeeData,
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

 




}
